import dayjs from 'dayjs';
import { LastSaved } from 'modules/notes/notePopup/noteView/addendumForm/lastSaved';

import style from './updatedLast.module.scss';

const UpdatedLast = ({
  lastSaved,
  updatedAt
}: {
  lastSaved: string | null;
  updatedAt?: string | null;
}) => {
  if (lastSaved) {
    return <LastSaved lastSaved={lastSaved} />;
  }

  if (updatedAt) {
    const formattedDate = dayjs(updatedAt).format('M/D/YYYY h:mm A');
    return (
      <p className={style.lastUpdated}>
        <span className="material-icons">check</span> Last updated {formattedDate}
      </p>
    );
  }

  return null;
};

export default UpdatedLast;
